module.exports = __webpack_public_path__ + "static/trapper-ca08aa04a5a2d823a8c5d7d03488f0b4.jpeg";